import { Pipe, PipeTransform } from '@angular/core';
import { toNumDE } from '../utils/to-num-de';

@Pipe({ name: 'numDE' })
export class NumDEPipe implements PipeTransform {
  transform(value?: number | string | null): string {
    return toNumDE(value);
  }
}
